import request from './index'

export function getInfo(type) {
  return request({
    url: `/user/${type}`,
    method: 'get'
  })
}

export function getDefaultCardNo() {
  return request({
    url: '/user/card/default',
    method: 'get'
  })
}

export function getCardNoList() {
  return request({
    url: '/user/card/list',
    method: 'get'
  })
}

export function getUserCard() {
  return request({
    url: '/user/card',
    method: 'get'
  })
}
